import type { ReactNode } from "react";

import { replaceNumericPlaceholders } from "./replace-numeric-placeholders";
import { replaceTemplateKeys } from "./replace-template-keys";

/**
 * 번역 원본 문자열(next-intl 의 t.raw 결과)을 렌더 가능한 HTML 문자열로 가공한다.
 *  1. {key} 토큰 치환
 *  2. %d 등 숫자 지정자 치환
 *  3. 리터럴 "\n"(Lokalise 원본의 백슬래시+n)을 <br /> 로 변환
 */
export const getTranslatedString = (
  raw: string,
  values: Record<string, ReactNode | string>
): string => {
  let rawHtml = raw;
  rawHtml = replaceTemplateKeys(rawHtml, values);
  rawHtml = replaceNumericPlaceholders(rawHtml, values);
  rawHtml = rawHtml.replace(/\\n/g, "<br />");
  return rawHtml;
};
